import React from "react";

export const PlansContext = React.createContext({
  plansFromJSON: null,
  setPlansFromJSON: () => {}
});


export const SimuladaoContext = React.createContext({
  simuladaoFromJSON: null,
  setSimuladaoFromJSON: () => {}
});



export default function Contexts({ children }) {
  return children
}
